import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { AspectRatio } from '../aspect-ratio/AspectRatio.js';
import { Image } from '../image/Image.js';

var ContainImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "AspectImage__ContainImage",
  componentId: "sc-1qi7kkh-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  object-fit: contain;\n  object-position: bottom center;\n"], ["\n  object-fit: contain;\n  object-position: bottom center;\n"])));
var AspectImage = function (_a) {
  var ratio = _a.ratio,
    rest = __rest(_a, ["ratio"]);
  return React__default.createElement(AspectRatio, {
    ratio: ratio
  }, React__default.createElement(ContainImage, __assign({
    width: "100%",
    height: "100%"
  }, rest)));
};
AspectImage.defaultProps = {
  ratio: 1 / 1
};
var templateObject_1;

export { AspectImage };
//# sourceMappingURL=AspectImage.js.map
